import { ReactNode, useRef } from "react";

import { GlobalLayout } from "@newsela/angelou";

import CEFooter from "@/base/CEFooter/CEFooter";
import { NavigationBar } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar";
import { NavigationBarProvider } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar.provider";
import {
  globalLayoutCss,
  mainCss,
} from "@/base/NewselaGlobalLayoutV2/NewselaGlobalLayoutV2.styles";
import ErrorBoundary from "@/components/ErrorBoundary";
import ErrorPage from "@/errors/ErrorPage";
import useTrialExtensionBanner from "@/home/useTrialExtensionBanner/useTrialExtensionBanner";
import useAssignmentPreview from "@/interactiveVideos/AssignmentPreview/assignmentPreview";
import AssignmentPreviewBanner from "@/interactiveVideos/AssignmentPreview/AssignmentPreviewBanner";
import { UserLicensesProvider } from "@/users/useUserLicenses";
import useIsAtHomePage from "@/view/utils/useIsAtHomePage";
import { RefProvider } from "./RefContext.provider";
import { TrialBanner } from "./NavigationBar/PremiumTrial/TrialBanner/TrialBanner.component";

const NewselaGlobalLayoutV2 = ({
  mainContents,
  hideHeader,
}: IGlobalLayoutV2) => {
  const isAtHomePage = useIsAtHomePage();
  const isAssignmentPreview = useAssignmentPreview();
  const {
    loading: loadingTrialExtensionBanner,
    show: showTrialExtensionBanner,
  } = useTrialExtensionBanner();
  const layoutRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div id="banner-root" />
      <div id="modal-root" />

      <RefProvider layoutRef={layoutRef}>
        <div css={globalLayoutCss} ref={layoutRef} data-testid="lyceum">
          {!hideHeader && !isAssignmentPreview && (
            <UserLicensesProvider>
              <NavigationBarProvider>
                <NavigationBar />
              </NavigationBarProvider>
            </UserLicensesProvider>
          )}
          <TrialBanner
            hideHeader={
              hideHeader ||
              loadingTrialExtensionBanner ||
              showTrialExtensionBanner
            }
          />

          {isAssignmentPreview && (
            <AssignmentPreviewBanner
              __css={GlobalLayout.headerHorizontalPaddingCss}
            />
          )}

          <ErrorBoundary FallbackComponent={ErrorPage}>
            <main css={mainCss} id="main-contents">
              {mainContents}
            </main>
          </ErrorBoundary>

          {isAtHomePage && <CEFooter />}
        </div>
      </RefProvider>
    </>
  );
};

interface IGlobalLayoutV2 {
  mainContents: ReactNode;
  hideHeader: boolean;
}
NewselaGlobalLayoutV2.displayName = "NewselaGlobalLayoutV2";
export { NewselaGlobalLayoutV2 };
